import 'raf/polyfill'
import 'babel-polyfill'
import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Link} from "react-router-dom"
import ReturnList from '../../component/return-pre-list/list.js'
import GiftAlert from '../../component/gift-alert/gift-alert.js'
import Authenticate from '../../component/authenticate/authenticate.js'
import HeaderM  from '../../component/headerM/headerM.js'
import {userList} from '../../redux/chatuser.redux.js'
import {authenticationFn} from '../../redux/chatuser.redux.js'
import {authenMsg} from '../../redux/chatuser.redux.js'
import ToastBar from '../../component/toast/toast.js'
import {getElementPosition} from '../../util.js'
import ReturnList89 from '../../component/return-pre-list/list89.js'
import ReturnList7910 from '../../component/return-pre-list/list7910.js'
import ReturnList78 from '../../component/return-pre-list/list78.js'
import ReturnGetALert from '../../component/return-get-alert/alert.js'
import ReturnGetALert7910 from '../../component/return-get-alert/alert7910.js'
import ReturnGetALert78 from '../../component/return-get-alert/alert78.js'
import './detail.css'
@connect(
  state=>state.chatuser,
  {userList,authenticationFn,authenMsg}
)
class returnDetail extends React.Component{
	constructor(props){
		super(props)
		
		this.state={
  			
		   getCates:null,
		   money:'',
		   accountData:'',
		   gameInfo:'',
		   handleValData:'',
		   asideNum:0,
		   detailVla:'',
		   showSelectWelfare:false,
		   parmeKey:'',
		   asideDataOff:false
		 
		  
    	} 	
    	this.game_id = this.props.match.params.id
    	this.gameXiaoHao = '回归后消耗累积金额'
    	this.propsAuthenticationData = this.propsAuthenticationData.bind(this)
    	this.asideData =['账号鉴定','定制礼包','消耗福利','专属客服']
    	
    	this.handleVla = this.handleVla.bind(this)
    	this.ToastBarClose = this.ToastBarClose.bind(this)
    	this.iTop=''
    	this.moneyArr = []

    	if(this.props.match.params.id==='89'){
    		this.asideData =['账号鉴定','定制礼包','消耗福利','专属客服']
    	}
    	if(this.game_id==='791000306'){
    		this.gameXiaoHao = '回归充值累积金额'
    	}
	}
	componentDidMount(){
  		this.getGameInfo()
    	this.handleGetMoney()
    	
    	
    	this.setState({
    		showSelectWelfare:false,
    		parmeKey:''
    	})

		
  	}
  	componentWillReceiveProps(nextProps){
  		
  		this.setState({
    		showSelectWelfare:false
    	})
    	if(this.props.match.params.id!==nextProps.match.params.id){
    		this.setState({
    			parmeKey:nextProps.match.params.id,
    			showSelectWelfare:false
    		})
    		this.game_id = nextProps.match.params.id
    		this.getGameInfo()
    		this.handleGetMoney()
    	
    	}
    	
  	}
  
  	handleLogin(){	
  		if(this.props.userlist.code===-1){
  			const pathname = this.props.location.pathname
			axios.get('/fapi/getLoginURL?redirect_url='+encodeURIComponent(encodeURIComponent(window.location.href)))
		      .then(res=>{
		       	if(res.data.return_code==0){
		       		window.location.href = res.data.redirect_url
		 
		       	}
						     
			 })		
  		}	
		
			
	}
	handleGetMoney(){
		axios.get('/fapi/recom/getMoney?game_id='+this.game_id+'')
  			.then(res=>{
  					
  					if(this.props.userlist.code===-1){
  					
	  						this.setState({
	  							money:'点击查看'
	  						})
  						
  					}else{
  						this.setState({
	  						money:res.data.data.money+'元'
	  						//money:0+'元'
	  					})
  					}
  					  					
  					
  				
  			})
	}
	getGameInfo(){
		axios.get('/fapi/recom/getGameInfo?game_id='+this.game_id+'')
			.then(res=>{
				if(res.data.return_code===0){
					this.setState({
						gameInfo:res.data.data
					})
					
					
				}else{

					alert('游戏还未开放回归特权，敬请期待')
					const iUrl = window.location.origin
					window.location.href=iUrl+'/return-m'
					//this.props.history.push('/return-m')
				}
				
			})
	}
	handlePower(num){
		
		var num = parseFloat(num)
  		
  		if(this.game_id==='89'){
  			this.moneyArr = ['1','200','500','1000','3000']
			
  			for(var i=0;i<this.moneyArr.length;i++){
  				if(num&&num<this.moneyArr[i]){
  					
					
  					return 4.9/(this.moneyArr.length-1)*(i-1)+1+'rem'
	  			}
	  			if(num&&num>=this.moneyArr[4]){
	  				return 5+'rem'
	  			}
  				
  			}
			
  		}else if(this.game_id==='791000306'){
			if(num>=1&&num<1000){
				return '0.3rem'
			}else{
				if(num>10000){num=10000}
				return  num/10000*5+'rem'
			}
			

  		}else{
  			this.moneyArr = ['1','1000','5000']

  			for(var i=0;i<this.moneyArr.length;i++){
  				if(num&&num<this.moneyArr[i]){
						
  					return 4.9/(this.moneyArr.length-1)*(i-1)+1+'rem'
	  			}
	  			if(num&&num>=this.moneyArr[2]){
	  				return 5+'rem'
	  			}
  				
  			}
  			
  		}
  	}
  	propsAuthenticationData(data){
		
  		this.setState({
  			accountData:data
  		})
  		
  	}
  	handleAsideFnCode(e){

  		this.setState({
 			asideDataOff:false
 		})

 		e.stopPropagation()
  	}
 	handleAsideFn(e,i){
 		const arr = ['200','400','1000','']
 		this.setState({
 			asideNum:i
 		})
 		if(i===3){
 			//this.props.authenMsg(this.state.detailVla)
 			//this.props.history.push('/return-m')
 			
 			this.setState({
 				asideDataOff:true
 			})

 		}else{
 			this.setState({
 				asideDataOff:false
 			})
 			if(i===4)return
 			window.scrollTo(0,arr[i])
 		}
 		/*
 		if(i===3){
 			this.props.authenMsg(this.state.detailVla)
 			this.props.history.push('/return-m')

 		}else{
 			if(i===4)return
 			window.scrollTo(0,arr[i])
 		}
 		*/
 		e.stopPropagation()
 	}
 	handleVla(data){
  		this.setState({
  			detailVla:data
  		})
  	}
  	showRole(e){
  		this.setState({
  			showSelectWelfare:true,
  			
  		})
  		this.iTop = getElementPosition(e.target).y+200+'px'
  	}
	ToastBarClose(data){
		this.setState({
  			showSelectWelfare:false,
  			
  		})
		

	}

  	render(){
  		if(this.game_id==89){
  			var ReturnListCon = ReturnList89
  		}
  		else if(this.game_id==791000306){
			var ReturnListCon = ReturnList7910
  		}
  		else if(this.game_id==78){
			var ReturnListCon = ReturnList78
  		}
  		else{
  			var ReturnListCon = ReturnList
  		}
  		return (
				<div className="return-detail-box" onClick={(e)=>this.handleAsideFnCode(e)}>
					<HeaderM></HeaderM>

					<aside className="return-aside">
						{
							this.asideData.map((item,i)=>(
							
								 <div 
								 	className={this.state.asideNum===i?'active-'+i+'':''}
								 	key={i} 
								 	onClick={(e)=>this.handleAsideFn(e,i)}
								 	
								 >
									 {
									 	i==3?
									 	<span style={{left:this.state.asideDataOff?'-3.2rem':'-320rem'}}></span>:''
									 	
										 
										
									 }
								 </div>
							
							))
					}
					</aside>
					
					<section className="return-detail-sec1">

						{
							this.state.gameInfo.newgamepage_img&&<div className={'game-logo-'+this.game_id}
								style={{backgroundImage:'url('+this.state.gameInfo.newgamepage_img+')'}}>
							
							</div>
						}
						<div className="authenticate-box">
							{this.game_id==='89'?<div className="game89-icon"></div>:''}
							{this.game_id==='791000306'?<div className="game7910-icon"></div>:''}
							{this.game_id==='78'?<div className="game78-icon"></div>:''}
							<Authenticate 
								propsAuthenticationData={this.propsAuthenticationData}
								handleVla={this.handleVla}
								gameInfo={this.state.gameInfo}
							></Authenticate>
							<a href="javascript:;" className="return-role" onClick={(e)=>this.showRole(e)}></a>
						</div>
						
					</section>
					<section className="return-detail-sec2">
						<ReturnListCon 
							key={this.state.parmeKey?2:false}
							ikey={this.state.parmeKey?2:false}
							navData={['钻石礼包','白金礼包','黄金礼包']} 
							inum='1'
							accountData={this.state.accountData}
						></ReturnListCon>
						<div className="return-gefl">

							<header><a href="javascript:;" className="return-role" onClick={(e)=>this.showRole(e)}></a></header>
							{
								this.props.authentication==2?<div className="return-sum-2"></div>:<div className="return-sum">
									{this.gameXiaoHao}：
									<strong onClick={()=>this.handleLogin()}>{this.state.money}
									</strong>
								</div>
							}
							{
								this.game_id==='791000306'?
									<div>
										<div className="return-power-box">
											<div className="return-power-num return-power-num2" style={{width:this.handlePower(this.state.money)}}>
												
												{

													parseFloat(this.state.money)<1000&&parseFloat(this.state.money)>=1?
														<i style={{left:'0.1rem'}}></i>:
															parseFloat(this.state.money)>12888?<i style={{left:'4.7rem'}}></i>:
															<i style={{
																	display:this.props.userlist.code===-1||parseFloat(this.state.money)===0?'none':'block',
																		
																	left:(parseFloat(this.state.money)/12888*5-0.3)+'rem'
																}}>
																
															</i>
												}
																				
											</div>
										</div>
										<div className="return-show-num return-show-num2">
											<span>1元</span>
											
											<span>12888元</span>
										</div>
									</div>:
								<div>
									<div className="return-power-box">
										<div className="return-power-num" style={{width:this.handlePower(this.state.money)}}></div>
										{
											this.moneyArr.map((item,i)=>(
												<i  key={i} style={{left:(4.9/(this.moneyArr.length-1))*(i)+'rem'}} ></i>

											))
										}
										
										
									</div>
									<div className="return-show-num">
										{
											this.moneyArr.map((item,i)=>(
												<span key={i} style={{left:(4.9/(this.moneyArr.length-1))*(i)+'rem'}} >{item+'元'}</span>

											))
										}
										
									</div>
								</div>
							}
						</div>
						<ReturnListCon 
							key={this.state.parmeKey?1:0}
							ikey={this.state.parmeKey?1:0}
							navData={['1元消耗礼包','1000元消耗礼包','5000元消耗礼包']} 
							inum='2'
							accountData={this.state.accountData}
							iMoney={this.state.money}
						></ReturnListCon>

					</section>
					{
						this.state.showSelectWelfare&&<ToastBar visible={this.state.showSelectWelfare} 
							title={'领取规则'}  
							isOkShow ={false} 
							iTop={this.iTop}
							ToastBarClose={this.ToastBarClose}
							
						>	
							{this.game_id==='89'?<ReturnGetALert></ReturnGetALert>:''}
							{this.game_id==='791000306'?<ReturnGetALert7910></ReturnGetALert7910>:''}
							{this.game_id==='78'?<ReturnGetALert78></ReturnGetALert78>:''}
						</ToastBar>

						
					}
				</div>
			
  		)
  	}
  	
}

export default returnDetail




// WEBPACK FOOTER //
// ./src/container/return-detail/detail.js